/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Jr_TitleInputs */

const en_cp_jr_title = /** @type {(inputs: Cp_Jr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 2-hour entry, an exit into grants and incubators`)
};

const id_cp_jr_title = /** @type {(inputs: Cp_Jr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pintu masuk 2 jam, pintu keluar ke P2MW dan inkubator`)
};

/**
* | output |
* | --- |
* | "A 2-hour entry, an exit into grants and incubators" |
*
* @param {Cp_Jr_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_jr_title = /** @type {((inputs?: Cp_Jr_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Jr_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_jr_title(inputs)
	return en_cp_jr_title(inputs)
});